var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customer"},[_c('van-sticky',[_c('div',{staticClass:"header"},[_c('div',{staticClass:"headerIcon"},[_c('van-search',{staticStyle:{"margin":"0 10px"},attrs:{"placeholder":"查找"}})],1)]),_vm._v(" "),_c('div',[_vm._v("\n      诊室页面待开发。。。\n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2486726c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/customerReception/reception.vue
// module id = null
// module chunks = 